import { render } from "./b-text-long.vue?vue&type=template&id=29437d2a&scoped=true"
import script from "./b-text-long.vue?vue&type=script&lang=js"
export * from "./b-text-long.vue?vue&type=script&lang=js"

import "./b-text-long.vue?vue&type=style&index=0&id=29437d2a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29437d2a"]])

export default __exports__